
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { resetPassword } from 'actions'
import Reset from '../components/Reset'

class ResetApp extends Component {
  render () {
    return React.createElement(Reset, this.props)
  }

  componentDidMount () {
    window.analytics.page('Password', 'Reset')
  }
}

function mapStateToProps (state) {
  return state.application.reset
}

function mapDispatchToProps (dispatch) {
  return {
    onSubmit: data => dispatch(resetPassword(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetApp)



// WEBPACK FOOTER //
// ./containers/ResetApp.js